<template>
  <div class="k-offer-card">
    <div class="image">
      <k-icon
        v-if="offer.partner.is_exclusive"
        icon="favorite-filled"
        class="exclusive"
      />
      <img
        :src="offer.partner.logo"
        class="logo"
        :alt="offer.partner.name"
      >
    </div>
    <div class="content">
      <div class="info">
        <h2 class="title">
          {{offer.title}}
        </h2>
        <div
          class="category"
          v-if="offer.category"
        >
          {{offer.category}} {{distance}}
        </div>
        <like
          :liked="offer.is_favorited"
          :likes="offer.likes"
          @like="$emit('like')"
          @unlike="$emit('unlike')"
          class="-k-offer-likes"
        />
      </div>
      <div class="tags">
        <k-tag
          v-if="offer.value"
          color="primary-2"
          class="k-offer-card-tag"
        >
          {{off}}
        </k-tag>
        <k-tag
          v-if="offer.eventData.is_cashback"
          class="k-offer-card-tag"
        >
          {{cashback}}
        </k-tag>
      </div>
    </div>
  </div>
</template>

<script>
import Like from './Like.vue';
export default {
  name: 'KOfferCard',
  components: {
    KTag: () => import('./KTag.vue'),
    KIcon: () => import('./KIcon.vue'),
    Like,
  },
  props: {
    offer: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    cashback () {
      const cashbackData = this.offer.eventData
      if (!cashbackData.is_cashback) return null
      const cashbackValue = cashbackData.cashback_value.toFixed(1)
      if (cashbackData.cashback_symbol === '%')
        return `${cashbackValue}${cashbackData.cashback_symbol} cashback`
      return `${cashbackData.cashback_symbol} ${cashbackValue}  cashback`
    },
    off () {
      if (!this.offer.value) return null
      if (this.offer.symbol === '%') return `${this.offer.value} ${this.offer.symbol} off`
      return `${this.offer.symbol} ${this.offer.value}`
    },
    distance () {
      if (this.offer.distance) {
        const distance = `${this.offer.distance}`.replace('.', ',')
        return ` • ${distance} km`
      }
      return null
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../assets/scss/main.scss";

.k-offer-card {
  display: flex;
  padding: 20px;
  max-width: 420px;
  height: 148px;
  transition: all ease 0.3s;
  &:hover {
    background: rgba(32, 41, 80, 0.03);
  }
  .image {
    width: 108px;
    height: 108px;
    background: rgba(24, 50, 115, 0.06);
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 8px;
    .exclusive {
      position: absolute;
      top: -8px;
      right: -14px;
      font-size: 24px;
      -webkit-text-stroke: 2px white;
      color: #ffd103;
    }
    .logo {
      max-width: 80px;
    }
  }
  .content {
    padding-left: 20px;
    width: 250px;
    height: 136px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title {
      margin: 0px;
      padding-bottom: 8px;
      @include heading-4;
    }
    .category {
      text-align: left;
      margin-bottom: $spacing-xs;
      color: rgba($neutral-1, 0.4);
      font-size: 16px;
    }
    .-k-offer-likes {
      margin-bottom: $spacing-s;
    }
    .tags {
      display: flex;
      .k-offer-card-tag + .k-offer-card-tag {
        margin-left: $spacing-xs;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KOfferCard.vue